const zIndex = {
  default: 0,
  reset: 1,
  unset: -1,

  shared: {
    autocomplete: 1
  },

  searchsuggest: {
    base: 4,
    fields: 5
  },

  layout: {
    feedback: 1,
    ads: 2,
    header: 3,
    menu: 4,
    overlay: 9
  },

  drawer: {
    overlay: 3,
    content: 4
  },

  filter: {
    panel: 5
  }
};

export default zIndex;
